export default __webpack_public_path__ + "static/media/image12.8b4329a9.jpg";